import $ from "jquery"
import { trace } from "./helpers.js"
import Cookies from "./Cookies.js"


const Popup = {
  
  init() {
    $('body').on("click", "#popup_banner a.close", (e)=> {
      e.preventDefault();
      let cName = $(e.currentTarget).data("cname");
      Cookies.createCookie(cName, 1, 7);
      $('#popup_banner').fadeOut(300);
    });

    $('body').on('click', '.video-popup a.close', (e) => {
      e.preventDefault();
      $('.video-popup').fadeOut(300);
    })
  }

}

export default Popup;